import { render } from "./FormRevisoes.vue?vue&type=template&id=787dc857"
import script from "./FormRevisoes.vue?vue&type=script&lang=js"
export * from "./FormRevisoes.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__